import Navbar from "../../components/Navbar";
import AsignarCitas from "../../components/dashboard_tecnico/AsignarCitas";
import ProximasCitas from "../../components/dashboard_tecnico/ProximasCitas";
import WidgetUnificado from "../../components/dashboard_tecnico/ItemsUnificados";
import { useState } from "react";
import "./css/Dashboard.css";

const DashboardAdmin = () => {
  const [categoria, setCategoria] = useState("destacados");

  return (
    <>
      <Navbar />

      <main className="dashboard-admin main-container-wrapper">
        <section className="portada between w-100 mb-100">
          {/* Sidebar izquierdo con citas */}
          <div className="column gap-25">
            <AsignarCitas />
            <ProximasCitas />
          </div>

          {/* Widget unificado a la derecha */}
          <div className="widget-unificado-container">
            <section className="empleo-destacado column">
              <div className="titulo-user flex justify-end pr-10">
                <div className="titulo-user align-center gap-10">
                  <select
                    aria-label="Filtrado por"
                    className="desplegable-empleo mayusculas p-2"
                    value={categoria}
                    onChange={(e) => setCategoria(e.target.value)}
                  >
                      <option value="destacados">TODOS</option>
                    <option value="destacados">DESTACADOS</option>
                    <option value="empleo">EMPLEO</option>
                    <option value="formacion">FORMACIÓN</option>
                    <option value="social">SOCIAL</option>
                  </select>
                </div>
              </div>
              <WidgetUnificado categoria={categoria} />
            </section>
          </div>
        </section>

        {/* <ListadoTareas /> */}
      </main>
    </>
  );
};

export default DashboardAdmin;
